/**
 * Mirrors <x-product-meta-category-path part="both"> (product-meta-category-path.blade.php)
 * so every CSR surface resolves a product's category breadcrumb the same way SSR does.
 */
import { CommonUtils } from "../../util/common-utils";

export interface CategoryBreadcrumbInput {
    categoryId?: number | string | null;
    categoryName?: string | null;
    parentCategoryId?: number | string | null;
    parentCategoryName?: string | null;
}

export function buildCategoryBreadcrumbHtml(input: CategoryBreadcrumbInput): string {
    const categoryIdRaw = input.categoryId;
    const categoryId =
        categoryIdRaw !== null && categoryIdRaw !== undefined && Number.isFinite(Number(categoryIdRaw))
            ? Number(categoryIdRaw)
            : null;
    const categoryName = String(input.categoryName ?? "").trim();

    const parentCategoryIdRaw = input.parentCategoryId;
    let parentCategoryId =
        parentCategoryIdRaw !== null &&
        parentCategoryIdRaw !== undefined &&
        Number.isFinite(Number(parentCategoryIdRaw))
            ? Number(parentCategoryIdRaw)
            : null;
    const parentCategoryName = String(input.parentCategoryName ?? "").trim();

    if (parentCategoryId === null && categoryId !== null) {
        const computedParentId = Math.floor(categoryId / 100) * 100;
        if (computedParentId > 0 && computedParentId !== categoryId) {
            parentCategoryId = computedParentId;
        }
    }

    const hasParentAndChild =
        parentCategoryName !== "" &&
        categoryName !== "" &&
        parentCategoryName.toLowerCase() !== categoryName.toLowerCase();

    const productsListUrl = CommonUtils.resolveUrl("/products");

    if (hasParentAndChild) {
        const parentHtml = parentCategoryId
            ? `<a href="${productsListUrl}?parent_category_id=${parentCategoryId}" class="meta-link">${CommonUtils.escapeHtml(parentCategoryName)}</a>`
            : `<span class="meta-link">${CommonUtils.escapeHtml(parentCategoryName)}</span>`;
        const childHtml = categoryId
            ? `<a href="${productsListUrl}?category_id=${categoryId}" class="meta-link meta-link--child">${CommonUtils.escapeHtml(categoryName)}</a>`
            : `<span class="meta-link meta-link--child">${CommonUtils.escapeHtml(categoryName)}</span>`;
        return `${parentHtml}<span class="meta-separator meta-separator--child" aria-hidden="true">/</span>${childHtml}`;
    }

    if (categoryName !== "" || parentCategoryName !== "") {
        const singleName = categoryName !== "" ? categoryName : parentCategoryName;
        const singleId = categoryName !== "" ? categoryId : parentCategoryId;
        const singleQueryKey = categoryName !== "" ? "category_id" : "parent_category_id";
        return singleId
            ? `<a href="${productsListUrl}?${singleQueryKey}=${singleId}" class="meta-link">${CommonUtils.escapeHtml(singleName)}</a>`
            : `<span class="meta-link">${CommonUtils.escapeHtml(singleName)}</span>`;
    }

    return '<span class="meta-link" data-translate="no_categorized">No categorized</span>';
}
